import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadTermsAndConditions from "./termsAndConditions/LoadTermsAndConditions";
import HasPermissionTo from "../../common/HasPermissionTo";
import { withTranslation } from "react-i18next";
import SubNav from "../../shared/subnav/SubNav";
import TranslationDetails from "../translations/TranslationDetails";

class NscBusinessSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: this.props.startingTab,
    };
  }

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  getTabs() {
    const { t, user } = this.props;
    const rolePermissions = user.permissions.rolePermissions;

    return [
      {
        menuName: t("ProgressBar.termsConditions"),
        enabled: true,
        id: "empMembership",
      },
      {
        menuName: t("ProgressBar.translations"),
        enabled: true,
        id: "translations",
        hide: !Object.hasOwn(rolePermissions, "translationsTab"),
      },
    ];
  }

  render() {
    const { t, user } = this.props;
    const rolePermissions = user.permissions.rolePermissions;

    return (
      <div>
        <SubNav
          dashboard={false}
          selectedTab={this.state.selectedTab}
          title={t("GlobalNavBar.settings")}
          action={this.handleTabChange}
          tabs={this.getTabs()}
          restrictDropdown={this.state.restrictDropdown}
          {...this.props}
        />
        <div className="pageWrapper">
          {this.state.selectedTab === 0 && (
            <LoadTermsAndConditions {...this.props} />
          )}

          <HasPermissionTo
            perform={["translationsTab"]}
            permissions={rolePermissions}
            condition={this.state.selectedTab === 1}
            render={() => <TranslationDetails {...this.props} />}
          />
        </div>
      </div>
    );
  }
}

NscBusinessSettings.propTypes = {
  startingTab: PropTypes.number,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.shape({
      rolePermissions: PropTypes.object,
    }),
  }).isRequired,
};

NscBusinessSettings.defaultProps = {
  startingTab: 0,
};

export default withTranslation("emp")(NscBusinessSettings);
